import React, { forwardRef } from 'react';
import { Input as BaseInput, styled } from 'tamagui';

import type { InputProps } from './Input';

const BaseStyledInput = forwardRef<BaseInput, InputProps>((props, ref) => (
    <BaseInput
        ref={ref}
        width="100%"
        textAlign="center"
        paddingHorizontal={6}
        borderWidth={0}
        allowFontScaling={false}
        hoverStyle={{
            outlineStyle: 'solid',
            outlineWidth: 2,
            outlineColor: '$gray800',
        }}
        focusVisibleStyle={{
            outlineColor: '$black',
            backgroundColor: '$gray100',
        }}
        {...props}
    />
));

const BaseStyledInputNoOutline = forwardRef<BaseInput, InputProps>(
    ({ disabled, ...props }, ref) => (
        <BaseInput
            ref={ref}
            borderWidth={0}
            outlineWidth={0}
            padding={0}
            backgroundColor="transparent"
            allowFontScaling={false}
            hoverStyle={{
                outlineWidth: 0,
                borderWidth: 0,
            }}
            focusVisibleStyle={{
                outlineWidth: 0,
                borderWidth: 0,
            }}
            disabled={disabled}
            {...props}
        />
    ),
);

export type StyledInput = typeof StyledBodyMediumRegularInput;

export const StyledBodyMediumRegularInput = styled(BaseStyledInput, {
    name: 'StyledBodyMediumRegularInput',
    fontFamily: '$body',
    fontSize: '$4',
    // @ts-expect-error - TODO tamagui upgrade: tokens are required and should be valid
    fontWeight: '$1',
});

export const StyledBodyMediumRegularInputNoOutline = styled(
    BaseStyledInputNoOutline,
    {
        name: 'StyledBodyMediumRegularInput',
        fontFamily: '$body',
        fontSize: '$4',
        // @ts-expect-error - TODO tamagui upgrade: tokens are required and should be valid
        fontWeight: '$1',
    },
);

export const StyledBodyMediumEmphasizedInput = styled(BaseStyledInput, {
    name: 'StyledBodyMediumEmphasizedInput',
    fontFamily: '$body',
    fontSize: '$4',
    // @ts-expect-error - TODO tamagui upgrade: tokens are required and should be valid
    fontWeight: '$2',
});

export const StyledH5Input = styled(BaseStyledInput, {
    name: 'StyledH5Input',
    fontFamily: '$heading',
    fontSize: '$2',
    // @ts-expect-error - TODO tamagui upgrade: tokens are required and should be valid
    fontWeight: '$1',
});

export const StyledH2Input = styled(BaseStyledInput, {
    name: 'StyledH2Input',
    fontFamily: '$heading',
    fontSize: '$3',
    // @ts-expect-error - TODO tamagui upgrade: tokens are required and should be valid
    fontWeight: '$1',
});

export const StyledH1EmphasizedInput = styled(BaseStyledInput, {
    name: 'StyledH1EmphasizedInput',
    fontFamily: '$heading',
    fontSize: '$4',
    // @ts-expect-error - TODO tamagui upgrade: tokens are required and should be valid
    fontWeight: '$2',
});

export const StyledH1EmphasizedInputNoOutline = styled(
    BaseStyledInputNoOutline,
    {
        name: 'StyledH1EmphasizedInput',
        fontFamily: '$heading',
        fontSize: '$4',
        // @ts-expect-error - TODO tamagui upgrade: tokens are required and should be valid
        fontWeight: '$2',
    },
);
